export enum FormType {
  UNKNOWN,
  STEP,
  FORM,
}
